export default __webpack_public_path__ + "static/media/cmc.ca332647.png";